import { Grid, Typography } from '@mui/material';
import CustomisedButton from '../../components/button/button';
import { IContainerApp } from '../navigationButtonComponents/loansTab/containerApp/IContainerApp';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { changeRouteType } from '../../redux/handleBackBtn/handleBackBtnSlice';
import { useAppBar } from '../../components/appBar/appBarContext';
import { getpervStateTab } from '../../redux/loansTab/loansTabSlice';
import AcceptIcon from '../../components/icons/AcceptIcon';

export default function Accept({ referenceKey, setStep, stepMain, setTabChild }: IContainerApp) {

    const dispatch = useDispatch();
    const { setHeader } = useAppBar();
    useEffect(() => {
        dispatch(changeRouteType({ routeType: 'infoDetail' }));
        setHeader('ثبت چک ضمانت', 'Accept')
    }, []);
    const handleWllet = () => {
        setTabChild!(1);
        dispatch(getpervStateTab({ prevState: 'wallet' }))
    }
    return (
        <div className='flex flex-col items-center justify-center' style={{ textAlign: 'center' }}>
            <AcceptIcon className="mt-10 text-[var(--primary-text-color)]" />
            <Typography className=" !mt-12 !font-bold text-[var(--primary-text-color)]">
                {stepMain === 'Assigned' ? <div>
                    کیف پول شما با <span className="secondaryColorLight-600">موفقیت</span> شارژ گردید.

                </div> : <><div>
                    درخواست شما با <span className="secondaryColorLight-600">موفقیت</span> ثبت شده است.

                </div><div>
                        نتیجه از طریق پیامک اطلاع رسانی خواهد شد.
                    </div></>}

            </Typography>
            {stepMain === 'Assigned' && <Grid container sx={{ my: '6em', px: '1em' }}>
                <Grid xs={12} sx={{ px: '.4em' }}>
                    <CustomisedButton
                        title="کیف پول"
                        disable={false}
                        onClick={handleWllet}
                        type="button"
                    />
                </Grid>
                {/* <Grid xs={6} sx={{ px: '.4em' }}>
                    <CustomisedButton
                        title="فروشگاه‌ها"
                        disable={false}
                        onClick={() => { }}
                        type="button"
                    />
                </Grid> */}
            </Grid>}
        </div>
    );
}
